export default __webpack_public_path__ + "static/kraken-e9bdcf8809b300170affe276c786de34.svg";